import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    flag: true,
    isFirstLoad: true, //查询红包的缓存标识
    cacheLevelRedPacketActivityList: [],
    cacheTotalTopUpRedPacketActivityList: [],
    cacheJackpotRedPacketActivity: [],
    Authorization: localStorage.getItem("SdkAuthorization")
      ? localStorage.getItem("SdkAuthorization")
      : "", // token
    channelId: localStorage.getItem("SdkChannelId")
      ? localStorage.getItem("SdkChannelId")
      : "", //渠道id
    deviceId: localStorage.getItem("SdkDeviceId")
      ? localStorage.getItem("SdkDeviceId")
      : "", //设备id
    gameId: localStorage.getItem("SdkGameId")
      ? localStorage.getItem("SdkGameId")
      : "", //游戏id
    gameUserId: localStorage.getItem("SdkGameUserId")
      ? localStorage.getItem("SdkGameUserId")
      : "", //游戏角色id
    privacyAuthorization: localStorage.getItem("SdkPrivacyAuthorization")
      ? localStorage.getItem("SdkPrivacyAuthorization")
      : "", //隐私政策授权提示 是否展示
    roleInfo: localStorage.getItem("SdkRoleInfo")
      ? localStorage.getItem("SdkRoleInfo")
      : "", //游戏角色完整信息 包括info  gameInfo: {gameUserId: "", //游戏用户id->001gameUserName: "", //游戏用户名称-testroleLevel: "", //角色等级rolePower: "", //角色战力gameServerId: "", //区服id gameServerName: "", //区服名称vipLevel: "", //vip等级},
    userInfo: localStorage.getItem("SdkUserInfo")
      ? localStorage.getItem("SdkUserInfo")
      : "", // 账号信息 age 年龄 userId 账号id  userName 注册手机号
    appOrH5: localStorage.getItem("SdkAppOrH5")
      ? localStorage.getItem("SdkAppOrH5")
      : "", // 区分游戏对接是 app端还是 H5端
    TotalTopPay: undefined,
  },
  mutations: {
    SET_FLAG(state, value) {
      state.flag = value;
    },
    // 修改token，并将token存入localStorage
    changeToken(state, user) {
      state.Authorization = user.access_token;
      localStorage.setItem("SdkAuthorization", user.access_token);
    },
    changeChannelId(state, user) {
      state.channelId = user;
      localStorage.setItem("SdkChannelId", user);
    },
    changeDeviceId(state, user) {
      state.deviceId = user;
      localStorage.setItem("SdkDeviceId", user);
    },
    changeGameId(state, user) {
      state.gameId = user;
      localStorage.setItem("SdkGameId", user);
    },
    changeGameUserId(state, user) {
      state.gameUserId = user;
      localStorage.setItem("SdkGameUserId", user);
    },
    changePrivacyAuthorization(state, user) {
      state.privacyAuthorization = user;
      localStorage.setItem("SdkPrivacyAuthorization", user);
    },
    changeRoleInfo(state, user) {
      state.roleInfo = user;
      localStorage.setItem("SdkRoleInfo", JSON.stringify(user));
    },
    changeUserInfo(state, user) {
      state.userInfo = user;
      localStorage.setItem("SdkUserInfo", JSON.stringify(user));
    },
    changeAppOrH5(state, user) {
      state.appOrH5 = user;
      localStorage.setItem("SdkAppOrH5", user);
    },
  },
  actions: {},
  getters: {},
});
